import { useState } from '@noshiro/preact-utils';
import { Maybe } from '@noshiro/ts-utils';
import { useEffect, useMemo } from 'preact/hooks';
export function useObservable(createObservable$) {
    const s = useMemo(createObservable$, []);
    useEffect(() => () => {
        s.complete();
    }, []);
    return s;
}
export const useObservableEffect = (observable$, subscriptionFn) => {
    useEffect(() => {
        const s = observable$.subscribe(subscriptionFn);
        return () => {
            s.unsubscribe();
        };
    }, []);
};
export function useObservableValue(observable$, initialValue) {
    var _a;
    const { state, setState } = useState({
        value: (_a = Maybe.unwrap(observable$.currentValue)) !== null && _a !== void 0 ? _a : initialValue,
    });
    useObservableEffect(observable$, (value) => {
        setState({ value });
    });
    return state.value;
}
